export const gradient = {
  blueGradient: [
    'rgba(88, 102, 173, 1) 0%',
    'rgba(83, 137, 184, 1) 55%',
    ' rgba(55, 176, 207, 1) 100%',
  ],
  blueGradientMain: 'rgb(88, 102, 173)',
};
